const HomePage = () => {
  return <h1>Homepage</h1>;
};

export default HomePage;
